import * as ko from 'knockout';

import { app } from '../app';
import i18n from '../i18n';
import { Deferred } from '../utils/deferred';

let template = require('raw-loader!../../templates/components/info_dialog.html').default;

class InfoDialog {
  title: string;
  text: string[];
  css: string;
  infoText: string;
  private result: Deferred<{}>;

  constructor(params: {
    title: string;
    text: string | string[];
    css: string;
    infoText: string;
    result: Deferred<{}>;
  }) {
    this.title = params.title;
    this.text = typeof params.text === 'string' ? [params.text] : params.text;
    this.css = params.css || '';
    this.infoText = params.infoText || i18n.t('OK')();
    this.result = params.result;
  }

  onClick = () => {
    this.result.resolve(null);
  };
}

ko.components.register('info-dialog', {
  viewModel: InfoDialog,
  template: template,
});

export function infoDialog(
  title: string,
  text: string | string[],
  css?: string,
  infoText?: string,
): Promise<{}> {
  return app.formsStackController.push({
    title: title,
    name: 'info-dialog',
    params: {
      title,
      text,
      css,
      infoText,
      result: new Deferred<{}>(),
    },
  });
}
